import React from 'react'
import { Trans } from '@lingui/react'
import ModalTopBar from './ModalTopBar'
import Modal, { ModalMainContainer } from './Modal'
import ModalConfirmButtonBar from './ModalConfirmButtonBar'

const DeleteTimerModal = ({ isSubmitting, onClose, onSubmit }) => (
    <Modal ariaLabel="Cancel timer">
        <ModalTopBar title={<Trans id="Cancel timer"/>} onClose={onClose} />
        <ModalMainContainer>
            <p>
                <Trans id="Are you sure you want to cancel this Timer?" />
                <br />
                <Trans id="All data related to this timer will be permanently removed!" />
            </p>
        </ModalMainContainer>
        <ModalConfirmButtonBar
            isSubmitting={isSubmitting}
            onCancel={onClose}
            onSubmit={onSubmit}
            submitText={<Trans id="Delete" />}
            submittingText={<Trans id="Deleting" />}
        />
    </Modal>
)

export default DeleteTimerModal
